<script>
import { slideImage } from '@/mixins/images'

export default {
    name: 'CircleImage',
    mixins: [ 
        slideImage,
    ],
    props: [
        'id',
        'media', 'single',
        'slug', 'text','alttext'
    ],
    computed: {
        style() {
            return !this.text ? `position: static; width: 100%; height: 100%;` : null
        },
        texted() {
            return this.text && this.text !== ' '
        },
    },
    render(h) {
        const { src, srcset, style, alttext } = this
        return h('img', {
            attrs: {
                src,
                srcset,
                style,
                alt: alttext,
            }
        })
    }
}
</script>
